import styled from "styled-components"
import { colors } from "../../helpers/colors"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  DescriptionStyles,
  HeadingWrapperStyles,
  CharactersWrapperStyles,
  DetailsStyles,
  SlideStyles,
  FeatureStyles,
  FeatureImageStyles,
  FeatureDescriptionStyles,
  SkinStyles,
  ImagesStyles,
  ImageStyles,
  ThumbnailsStyles,
  ThumbnailStyles,
  SlideNumberStyles,
} from "./characters-styles"

interface ISectionWrapper {
  bgImg?: string
}

interface ISelectable {
  selected?: boolean
}

export const SectionWrapper = styled.section<ISectionWrapper>`
  background-image: url(${props => props.bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  ${ContentWrapperStyles}
`

export const HeadingWrapper = styled.div`
  max-width: 544px;
  ${HeadingWrapperStyles}
`

export const Description = styled.p`
  ${DescriptionStyles}
`

export const CharactersWrapper = styled.div`
  display: flex;
  ${CharactersWrapperStyles}
`

export const Details = styled.div`
  position: relative;
  border: 1px solid ${colors.gray};
  width: 544px;
  padding: 40px 35px 50px 35px;
  & > .slick-slider {
    position: static;
    & > .slick-arrow {
      top: auto;
      bottom: 0;
      &.slick-prev {
        left: auto;
        right: 99px;
      }
      &.slick-next {
        right: 35px;
      }
    }
  }
  ${DetailsStyles}
`

export const SlideNumber = styled.span`
  color: ${colors.gray};
  ${SlideNumberStyles}
`

export const Slide = styled.div`
  ${SlideStyles}
`

export const Feature = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  ${FeatureStyles}
`
export const FeatureImage = styled.img`
  width: 100%;
  max-width: 84px;
  height: auto;
  ${FeatureImageStyles}
`

export const FeatureDescription = styled.div`
  margin-left: 25px;
  & > h6 {
    margin: 0;
    line-height: 1em;
  }
  ${FeatureDescriptionStyles}
`

export const Skin = styled.div<ISelectable>`
  cursor: pointer;
  margin: 15px 0;
  &:hover {
    color: ${colors.gray};
  }
  ${SkinStyles}
`

export const Images = styled.div`
  position: relative;
  flex: 1;
  ${ImagesStyles}
`

export const Image = styled.div`
  & > img {
    width: 100%;
  }
  ${ImageStyles}
`

export const Thumbnails = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  justify-content: center;
  ${ThumbnailsStyles}
`

export const Thumbnail = styled.div<ISelectable>`
  cursor: pointer;
  margin: 10px;
  ${ThumbnailStyles}
`
